<template>
  <div class="i_content">
    <div
      class="message"
      v-for="(item, index) in informationlist"
      :key="index"
      :class="{ wow: true, wo: ui }"
      :style="getdog(index)"
    >
      <div class="bk1">
        <el-image :src="item.full_cover" fit="fill" class="image-box" />
      </div>
      <div class="mationdetail">
        <div @click="topath(`/information/${item.id}`)">
          <!-- {{ (locale == "zh" && item.title) || item.en_title }} -->
          {{ item.title }}
        </div>
        <div>
          <!-- {{ (locale == "zh" && item.content) || item.en_content }} -->
          {{ item.content }}
        </div>
        <div>{{ item.created_at?.slice(0, 10) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  reactive,
  watch,
  watchEffect,
  ref,
  defineProps,
  onMounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const ui = ref(false);
const getdog = (e) => {
  return `transition: all ${1.5 + e * 0.2}s;`;
};
onMounted(() => {
  console.log(ui.value, "value");

  // Set a small timeout to ensure the DOM renders the `wow` class first
  setTimeout(() => {
    ui.value = true; // Trigger the `wo` class
  }, 1250); // 50ms ensures browser applies initial styles before transition
});
const props = defineProps({
  informationlist: {
    type: Object,
  },
  ani: {
    type: Boolean,
  },
});
const topath = (e) => {
  console.log(e, 112212);
  router.push(e);
};
</script>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.i_content {
  max-width: 1176px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .message {
    width: 48%;
    position: relative;
    display: flex;
    justify-content: center;
    height: 440px;
    &:last-child {
      margin-bottom: 50px;
    }
    .bk1 {
      width: 100%;
      height: 60%; // 高度使用百分比
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      position: relative;
      .image-box {
        // position:absolute;
        // bottom:0px;
        // left:0px;

        height: 100%;
        aspect-ratio: 16 / 6; /* 固定比例容器，统一大小 */
        // background-color: #FFF;
        width: auto !important;
        object-fit: contain; /* 保证完整显示 */
      }

      img {
        max-height: 100%; // 限制最大高度不超过容器
        height: 100%; // 保持高度百分比显示
        width: auto; // 宽度自适应
        object-fit: contain; // 保持图片比例完整显示
        display: block;
      }
    }
    .mationdetail {
      width: 70%;
      position: absolute;
      padding: 36px;
      background: #fff;
      text-align: left;
      top: 180px;
      :nth-child(1) {
        @include fontstyle(#333, 22px, 800, pointer);
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 限制显示的行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal; /* 防止文字溢出隐藏 */
        text-overflow: ellipsis;
        line-height: 26px;
        margin-bottom: 24px;
        &:hover {
          text-decoration: underline;
          @include fontstyle(#3657db, 22px, 800, pointer);
        }
      }
      :nth-child(2) {
        @include fontstyle(#333, 16px, 400, auto);
        display: -webkit-box;
        line-height: 26px;
        margin-bottom: 24px;
        -webkit-line-clamp: 2; /* 限制显示的行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal; /* 防止文字溢出隐藏 */
        text-overflow: ellipsis;
      }
      :nth-child(3) {
        @include fontstyle(#333, 16px, 400, auto);
        line-height: 26px;
        // margin-bottom: 100px;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .content {
    .i_content {
      .message {
        width: 100%;
        height: 450px;
        .mationdetail {
          width: 82% !important;
          top: 210px;
        }
      }
    }
  }
  .informationcontent {
    .i_content {
      .message {
        width: 100% !important;
        height: 400px !important;
        .mationdetail {
          width: 80% !important;
          top: 210px;
        }
      }
    }
  }
  .bk1 {
    // height: 60%; // 小屏幕高度可以略降
    // width:100%;
    // height: auto !important;
    .image-box {
      height: auto !important;
      aspect-ratio: 0 !important;
    }
    img {
      // max-height: 100%;
      height: auto;
      width: 100% !important;
    }
  }
}
</style>
